<template>
    <div>
        <!-- 搜索条件 -->
        <div style="display: flex;background: #fff;padding: 20px;">
            <el-input clearable v-model="form.searchValue" style="width: 280px;" size="mini" :placeholder="$t('view.请输入招标项目/招标单位以搜索')"></el-input>
            <div style="align-items: center;">
<!--                <span style="margin: 0 15px;">{{ $t('view.项目状态') }}:</span>-->
<!--                <el-select size="mini" style="width: 150px;" clearable v-model="form.sectionStauts" :placeholder="$t('view.项目状态')">-->
<!--                    <el-option v-for="item in stauts(sys_section_stauts) " :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>-->
<!--                </el-select>-->
                <span style="margin: 0 15px;">{{ $t('view.投标状态') }}:</span>
                <el-select size="mini" style="margin: 0 15px;" clearable v-model="form.supplierBidStatus" :placeholder="$t('view.投标状态')">
                    <el-option v-for="item in sys_supplier_bid_status" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
                <el-button size="mini" type="primary" @click="form.pageNum=1; signupList()">{{ $t('view.查询') }}</el-button>
            </div>
        </div>
        <div style="height: 20px;width: 100%;background: #F8F8F8"></div>
        <!-- 表格数据 -->
        <div style="background: #fff;padding: 20px;">
            <el-table  header-row-class-name="tableHeader" :data="tableData" style="width: 1010px" border>
                <el-table-column type="index" width="60" show-overflow-tooltip :label="$t('view.序号')"></el-table-column>
                <el-table-column prop="date" show-overflow-tooltip :label="$t('view.招标项目名称')" width="200">
                    <template slot-scope="scope">
                        <span class="clickText" @click="TenderAnnouncement( scope.row.biddingType==1?'InquiryAnnouncement':'TenderAnnouncement', scope.row.sectionId)">{{locale=='en'?scope.row.sectionNameEn:locale=='lo'?scope.row.sectionNameLo: scope.row.sectionName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="organization" show-overflow-tooltip :label="$t('view.招标单位')" width="150"></el-table-column>
                <el-table-column prop="businessContacts" show-overflow-tooltip :label="$t('view.招标联系人')" width="150">
                     <template slot-scope="scope">
                        <span>{{scope.row.section.businessContacts}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" align="center"  show-overflow-tooltip :label="$t('view.报名时间')" width="160"></el-table-column>
                <el-table-column prop="signStatus" align="center"  show-overflow-tooltip :label="$t('view.报名状态')"  width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.signStatus==1?$t('view.报名成功'):scope.row.signStatus==2?$t('view.报名失败'):$t('view.待审核')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="publishTime" align="center"  show-overflow-tooltip :label="$t('view.发布时间')" width="160"></el-table-column>
               <el-table-column prop="date" align="center" show-overflow-tooltip :label="$t('view.项目状态')" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.confirmationStatus==='0'">{{ $t('view.待完善价格') }}</span>
                        <span v-else-if="scope.row.confirmationStatus==20">{{ $t('view.价格审批驳回') }}</span>
                        <span v-else-if="scope.row.confirmationStatus==10">{{ $t('view.价格审批中') }}</span>
                        <span v-else-if="scope.row.biddingType==1">{{ getStatus('sys_section_stauts_client',scope.row.sectionStauts) }}</span>
                        <span v-else>{{ getStatus('sys_section_stauts_tenders_client',scope.row.sectionStauts) }}</span>
                    </template>
                </el-table-column>
                <!--  <el-table-column prop="date" align="center"  show-overflow-tooltip :label="$t('view.招标/询价')"  width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.biddingType==1?$t('view.询价'):$t('view.招标')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createByName" align="center"  show-overflow-tooltip :label="$t('view.投标人')" width="160"></el-table-column>
                <el-table-column prop="date" align="center"  show-overflow-tooltip :label="$t('view.投标状态')" width="150">
                    <template slot-scope="scope">
                        <span v-if="![6,14].includes(scope.row.sectionStauts)"> {{getStatus('sys_supplier_bid_status',scope.row.supplierBidStatus) }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="date" fixed="right" align="center"  show-overflow-tooltip :label="$t('view.操作')" width="150" >
                    <template slot-scope="scope">
                            <!--指定供应商报价-->
                        <span v-if="scope.row.isAppointSupplierQuotationIng==1">
                            <span class="clickText"   @click="warningTime(scope.row)">{{ $t('view.处理') }} </span>
                        </span>
                        <!-- 查看  -->
                        <span v-else-if="scope.row.sectionStauts==2||scope.row.sectionStauts==13||scope.row.sectionStauts==14||scope.row.sectionStauts==6||
                        scope.row.supplierBidStatus==14||scope.row.supplierBidStatus==20||scope.row.supplierBidStatus==-1">
                            <span class="clickText" @click="BidDetails(scope.row.id)">{{ $t('view.查看') }}</span>
                        </span>
                        <!-- 处理 -->
                        <span v-else>
                            <span class="clickText"   @click="warningTime(scope.row)">{{ $t('view.处理') }} </span>
                        </span>
                        <!-- 完善价格 -->
                        <span class="clickText" v-if="scope.row.isSectorSupplierAmount==1" :style="{'margin-left': '10px',color:(scope.row.confirmationStatus==='0'||scope.row.confirmationStatus==20)?'#B80008':'#4F62E7'}"  @click="handleImprovePrices(scope.row)">{{ $t('view.完善价格') }} </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;margin-top: 10px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <!-- 个人报名认证 -->
        <el-dialog :title="$t('view.个人认证')" :visible.sync="personalOpen" width="800px" append-to-body :close-on-click-modal="false">
        <el-form ref="authentication" :model="authentication" label-width="80px" :rules="rules">
            <div style="color: #B80008; margin-left: 160px;"> {{operationMsg}} </div>
            <el-form-item :label="$t('view.身份证(正面)')+':'" prop="corporateIdCardFront" label-width="160px">
                <div style="display: flex; flex-wrap: flex-start">
                <vuedraggable :list="authentication.corporateIdCardFront" :animation="200">
                    <div class="demo-upload-list" v-for="(item, __index) in authentication.corporateIdCardFront" :key="__index" >
                    <template>
                        <img :src="item.filePath" class="upload-image"/>
                        <div class="demo-upload-list-cover">
                        <div>
                            <i class="el-icon-search"   size="30" @click="handleViewGoodsPicture(item.filePath)"></i>
                            <i class="el-icon-delete-solid"  size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardFront,item)"></i>
                        </div>
                        </div>
                    </template>
                    </div>
                </vuedraggable>
                <el-upload action="#" :limit="3"
                    v-if="authentication.corporateIdCardFront.length == 0"
                    accept=".jpg, .jpeg, .png"  list-type="picture-card" :show-file-list="false"
                    :file-list="authentication.corporateIdCardFront" :http-request="corporateIdCardFrontUploadFile">
                    <i class="el-icon-plus"></i>
                </el-upload>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.身份证(反面)')+':'" prop="corporateIdCardOpposite" label-width="160px">
                <div style="display: flex; flex-wrap: flex-start">
                <vuedraggable :list="authentication.corporateIdCardOpposite" :animation="200">
                    <div class="demo-upload-list" v-for="(item, __index) in authentication.corporateIdCardOpposite" :key="__index">
                    <template>
                        <img :src="item.filePath" class="upload-image"/>
                        <div class="demo-upload-list-cover">
                        <div>
                            <i class="el-icon-search" size="30" @click="handleViewGoodsPicture(item.filePath)"></i>
                            <i class="el-icon-delete-solid" size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardOpposite,item)"></i>
                        </div>
                        </div>
                    </template>
                    </div>
                </vuedraggable>
                <el-upload action="#" :limit="3"
                    v-if="authentication.corporateIdCardOpposite.length == 0" accept=".jpg, .jpeg, .png" list-type="picture-card"
                    :show-file-list="false" :file-list="authentication.corporateIdCardOpposite" :http-request="corporateIdCardOppositeUploadFile">
                    <i class="el-icon-plus"></i>
                </el-upload>
                </div>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitAuthentication">{{ $t('view.确 定') }}</el-button>
            <el-button @click="cancel">{{ $t('view.取 消') }}</el-button>
        </div>
        </el-dialog>
        <!-- 审核提示 -->
         <el-dialog :title="$t('view.提示')" :visible.sync="promptOpen" width="700px" append-to-body :close-on-click-modal="false">
            <h1>{{promptText }}</h1>
            <div slot="footer" class="dialog-footer">
                <el-button @click="promptCancel">{{ $t('view.确 定') }}</el-button>
            </div>
        </el-dialog>
        <!-- 图片预览 -->
        <el-dialog :visible.sync="goodsPictureVisible" class="preview" :title="$t('view.图片预览')" :append-to-body="true" width="60%">
            <img :src="previewGoodsPicture" style="max-width: 100%; margin: 0 auto;margin-bottom: 20px;display: block;"/>
        </el-dialog>
        <PowerOfAttorney ref="PowerOfAttorney"></PowerOfAttorney>
    </div>
  </template>

<script>
import {signupList} from '@/api/PersonalCenter'
import {getDicts,warningTime} from '@/api/index'
import {getSectionByIdWithAuth,follow,quotationSignup,authorizationDownLoad,submitAuthorization, authorizationVerify, getAuthorization} from '@/api/project'
import {uploadAndBpm} from "@/api/common/common";
import vuedraggable from "vuedraggable";
import PowerOfAttorney from '@/components/PowerOfAttorney.vue'
import XEUtils from "xe-utils";
  export default {
    components: { vuedraggable ,PowerOfAttorney},
    data(){
        return{
            form:{
                pageSize:10,
                pageNum:1
            },
            tableData:[],
            total:0,
            locale: localStorage.getItem('locale')||'zh',
            sys_section_type:[],
            sys_section_stauts:[], //项目状态
            sys_section_stauts_tenders:[],//招标的项目状态
            sys_supplier_bid_status:[],//投标状态
            authentication:{
                businessLicenseFileList:[],
                isLegalRepresentative:"",
                businessLicenseStart:null,
                businessLicenseEnd:null,
                corporateIdCardFront:[],
                corporateIdCardOpposite:[],
                authorizationFileList:[],
                authorizationStart:null,
                authorizationEnd:null
            }, // 企业认证
            // 个人认证
            personalOpen:false,
            promptOpen:false,
            promptText:'',
            previewGoodsPicture:"",
            operationMsg:"",
            goodsPictureVisible: false,
            // 表单校验
            rules: {
                    businessLicenseFileList: [
                    { required: true, message: this.$t('view.请上传营业执照'), trigger: "blur" }
                    ],
                    businessLicenseStart: [
                    { required: true, message: this.$t('view.请选择营业执照有效期'), trigger: "blur" }
                    ],
                    businessLicenseEnd: [
                    { required: true, message:this.$t('view.请选择营业执照有效期'), trigger: "blur" }
                    ],
                    isLegalRepresentative: [
                    { required: true, message: this.$t('view.请选择是否法人'), trigger: "change" }
                    ],
                    corporateIdCardFront: [
                    { required: true, message: this.$t('view.请上传身份证(正面)'), trigger: "change" }
                    ],
                    corporateIdCardOpposite: [
                    { required: true, message: this.$t('view.请上传身份证(反面)'), trigger: "change" }
                    ],
                    authorizationFileList: [
                    { required: true, message: this.$t('view.请上传投标授权委托书'), trigger: "change" }
                    ],
                    authorizationStart: [
                    { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                    ],
                    authorizationEnd:[
                    { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                    ],
                },
        }
    },
    created(){
        this.getDicts('sys_section_type')
        this.getDicts('sys_section_stauts')
        this.getDicts('sys_section_stauts_client')
        this.getDicts('sys_section_stauts_tenders_client')
        this.getDicts('sys_supplier_bid_status')
        this.getDicts('sys_section_stauts_tenders')
        this.signupList()
    },
    methods:{
        warningTime(item){
            warningTime().then(res=>{
                if(res.data.error==0){
                    this.handleBidDetails(item)
                }else if(res.data.error==2){
                    this.promptText=this.$t('view.授权委托书已上传，目前正在审核中，请耐心等待')
                    this.promptOpen = true;
                } else{
                    this.$refs.PowerOfAttorney.show(res.data.authorizationBook.status==3?res.data.authorizationBook:{status:res.data.authorizationBook.status}, res.data.day)
                }
            })
        },
        stauts(e){
            let list=JSON.parse(JSON.stringify(e))
            list.map(item=>{
                if(item.dictValue==1)
                item.dictLabel=this.$t('view.询价中/报价中')
            })
            return list
        },
        // 查看
        BidDetails(id){
            this.$router.push({path:'BidDetails',query:{id:id}})
        },
        corporateIdCardFrontUploadFile(data){
            this.uploadFile(data,this.authentication.corporateIdCardFront);
        },
        handleImprovePrices(row){
            this.$router.push({path:'ImprovePrices',query:{id:row.id}})
        },
        // 处理
        handleBidDetails(row){
            let id = row.id;
            this.sectionId = row.sectionId;
            this.sectionName = row.sectionName;
            // 校验当前用户是否需要企业认证
            authorizationVerify().then(res=>{
                if(res.code==200){
                    if ('Auth' == res.data.operation) {
                        // 企业认证
                        this.reset();
                        if("0" == res.data.operationUserType){
                            let that=this
                            this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                confirmButtonText:that.$t('view.确定'),
                                cancelButtonText: that.$t('view.取消'),
                                type: 'warning'
                            }).then(() => {
                                that.$router.push('EnterpriseCertification')
                            })
                        }else{
                            this.personalOpen = true;
                        }
                        this.operationMsg = res.data.operationMsg;
                    }else if ('prompt' == res.data.operation){
                        this.promptText=this.$t('view.认证信息已上传，目前正在审核中，请耐心等待')
                        this.promptOpen = true;
                    }else if ('modify' == res.data.operation){
                        getAuthorization().then(res=>{
                            this.authentication = res.data;
                        });
                        // 企业认证
                        this.reset();
                        if("0" == res.data.operationUserType){
                            let that=this
                            this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                confirmButtonText:that.$t('view.确定'),
                                cancelButtonText: that.$t('view.取消'),
                                type: 'warning'
                            }).then(() => {
                                that.$router.push('EnterpriseCertification')
                            })
                        }else{
                            this.personalOpen = true;
                        }
                        this.operationMsg = res.data.operationMsg;
                    }else{
                        this.$router.push({path:'BidDetails',query:{id:id}})
                    }

                }
            })
        },
         // 招标详情
        TenderAnnouncement(url,id){
            let routeUrl= this.$router.resolve({
                path: url,
                query: {id:id}
            })
            window.open(routeUrl.href, '_blank');
        },
        // 字典项
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.signupList()
        },
        signupList(){
            signupList(this.form).then(res=>{
                this.tableData=res.rows
                this.total=res.total
            })
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.personalOpen = false;
            this.reset();
        },
        // 提示取消按钮
        promptCancel() {
            this.promptOpen = false;
        },
            // 表单重置
        reset() {
            this.authentication = {
                businessLicenseFileList: [],
                isLegalRepresentative:"",
                businessLicenseStart:null,
                businessLicenseEnd:null,
                corporateIdCardFront:[],
                corporateIdCardOpposite:[],
                authorizationFileList:[],
                authorizationStart:null,
                authorizationEnd:null
            };
            this.resetForm("authentication");
        },
        // 提交
        submitAuthentication(){
            this.authentication.sectionId = this.sectionId;
            this.authentication.sectionName = this.sectionName;
            console.log(this.authentication);
            this.$refs["authentication"].validate(valid => {
                if (valid) {
                    submitAuthorization(this.authentication).then(response => {
                        this.$message.success(this.$t('view.提交成功'));
                        this.open = false;
                        this.personalOpen = false;
                        this.reset();
                    });
                }
            });
        },
        handleViewGoodsPicture(url) {
            this.previewGoodsPicture = url;
            this.goodsPictureVisible = true;
        },
        corporateIdCardOppositeUploadFile(data){
            this.uploadFile(data,this.authentication.corporateIdCardOpposite);
        },
        authorizationFileListUploadFile(data){
            this.uploadFile(data,this.authentication.authorizationFileList);
        },
        handleRemoveGoodsPicture(fileList,file) {
            XEUtils.remove(fileList, (item) => item.filePath === file.filePath); // el-upload 删除
        },
        // 下载模版
        downloadTemplate(){
            authorizationDownLoad().then(res=>{
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.$t('view.投标授权委托书模板.docx');
                link.click();
            })
        },
        // 附件上传
        uploadFile(data,fileList) {
            console.log(fileList);
            // 判断是否大于10M
            if (data.file.size / 1024 / 1024 > 1024) {
                this.$message({
                message: this.$t('view.上传文件不能超过20MB'),
                type: "warning"
                });
                this.uploadLoading = false;
                return;
            }
            if (data.file.size == 0) {
                this.$message({
                message: this.$t('view.上传文件不能为0KB'),
                type: "warning"
                });
                return;
            }
            let formData = new FormData();
            formData.append("file", data.file);
            formData.append("type", "qyrzsp");
            uploadAndBpm(formData).then(response => {
                if (response.code === 200) {
                    this.$message({ message: this.$t('view.上传成功'), type: "success" });
                    fileList.push(response.data);
                }
            }).catch(err => {
            });
        },
    }
};
</script>
<style lang="scss" scoped>
    .title{
        font-size: 16px;
        font-weight: 700;
        border-left: solid 3px $mainBody-color;
        padding-left: 5px;
    }
    .upload-image {
        width: 400px; /* 根据需要调整宽度 */
        height: auto; /* 保持宽高比 */
    }
</style>
